import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";

const adminToken = secureStorage.getItem("adminToken");
const API_URL = "/admin/local/city";

const headers = {
  Authorization: `Bearer ${adminToken}`,
  "Content-Type": "application/json",
};

const initialFormData = {
  id: null,
  cityName: "",
  countryId: "",
  divisionId: "",
  isFeatured: 0,
  status: 1,
};

export const viewCity = async (setCityData, setLoading) => {
  if (setLoading) setLoading(true);

  try {
    const res = await axiosInstance.get(API_URL, { headers });
    setCityData(res.data.data || []);
    return true;
  } catch (error) {
    console.error("View city error:", error);
    toast.error(error.response?.data?.message || "Failed to fetch cities");
    return false;
  } finally {
    if (setLoading) setLoading(false);
  }
};

export const addCity = async (
  FormData,
  setFormData,
  setCityData,
  setLoading,
) => {
  try {
    const res = await axiosInstance.post(API_URL, FormData, { headers });

    if (res.data.message === "City added successfully") {
      toast.success("City added successfully");
      setFormData({ ...initialFormData });
      await viewCity(setCityData, setLoading);
      return true;
    }

    toast.error(res.data.message || "Failed to add city");
    return false;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to add city");
    return false;
  }
};

export const updateCity = async (
  FormData,
  setFormData,
  setCityData,
  setLoading,
) => {
  try {
    const res = await axiosInstance.put(API_URL, FormData, { headers });

    if (res.data.message === "City updated successfully") {
      toast.success("City updated successfully");
      setFormData({ ...initialFormData });
      await viewCity(setCityData, setLoading);
      return true;
    }

    toast.error(res.data.message || "Failed to update city");
    return false;
  } catch (error) {
    console.error("Update city error:", error);
    toast.error(error.response?.data?.message || "Failed to update city");
    return false;
  }
};

export const deleteCity = async (id, setCityData, setLoading) => {
  try {
    const res = await axiosInstance.delete(API_URL, {
      headers,
      data: { id },
    });

    if (res.data.message === "City deleted successfully") {
      toast.success("City deleted successfully");
      await viewCity(setCityData, setLoading);
      return true;
    }

    toast.error(res.data.message || "Failed to delete city");
    return false;
  } catch (error) {
    console.error("Delete city error:", error);
    toast.error(error.response?.data?.message || "Failed to delete city");
    return false;
  }
};
